import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

// Campos compartilhados pelas duas portas do aplicativo — a do cliente
// (`EntradaApp`) e a da equipe (`EntradaLoja`). Moraram dentro do `EntradaApp` ate
// 14/08/2026; sairam de la quando a segunda porta nasceu, pra nao existirem dois
// campos de senha com dois comportamentos ligeiramente diferentes.

export const estiloCampo: React.CSSProperties = {
  width: '100%',
  height: 52,
  padding: '0 14px',
  // 16px trava o zoom automatico do iOS ao focar um campo — mesma razao do catalogo.
  fontSize: 16,
  border: '1px solid #d1d5db',
  borderRadius: 10,
  backgroundColor: '#fff',
  color: '#111',
};

/**
 * Campo de senha com o olho de "ver o que eu digitei".
 *
 * Cada campo tem o SEU olho, e nao um so pros dois: quem esta conferindo se a
 * confirmacao bate precisa poder abrir uma e manter a outra escondida. Um olho
 * unico governando os dois campos resolveria o caso facil e atrapalharia
 * justamente o caso em que ele serve.
 *
 * O botao fica DENTRO da moldura do campo, e o input reserva espaco pra ele
 * (`paddingRight`) — senao o olho cobre o fim do texto digitado, que e' o pedaco
 * que a pessoa mais quer ver.
 */
export function CampoSenha({
  rotulo, valor, aoMudar, autoComplete, placeholder,
}: {
  rotulo: string;
  valor: string;
  aoMudar: (v: string) => void;
  autoComplete: string;
  placeholder?: string;
}) {
  const [visivel, setVisivel] = useState(false);
  return (
    <label style={{ display: 'block' }}>
      <span style={{ fontSize: 14, fontWeight: 600 }}>{rotulo}</span>
      <div style={{ position: 'relative', marginTop: 6 }}>
        <input
          className="no-upper"
          style={{ ...estiloCampo, paddingRight: 50 }}
          value={valor}
          onChange={(e) => aoMudar(e.target.value)}
          type={visivel ? 'text' : 'password'}
          autoComplete={autoComplete}
          placeholder={placeholder}
        />
        <button
          type="button"
          onClick={() => setVisivel((v) => !v)}
          aria-label={visivel ? 'Esconder senha' : 'Mostrar senha'}
          style={{
            position: 'absolute', right: 4, top: 4, width: 44, height: 44,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#6b7280', background: 'transparent',
          }}
        >
          {visivel ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
      </div>
    </label>
  );
}
